import React, { useEffect, useState } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { Alert, Box, CircularProgress } from '@mui/material';
import { PublicStorefront, publicStorefrontApi, StorefrontApiError } from '../../services/storefrontService';
import { StorefrontProvider, useStorefront } from '../../components/Storefront/StorefrontContext';
import StorefrontLayout from '../../components/Storefront/StorefrontLayout';
import { useStorefrontT } from '../../components/Storefront/useStorefrontT';

const Frame: React.FC = () => {
    const { slug, storefront, cart } = useStorefront();
    return (
        <StorefrontLayout slug={slug} storefront={storefront} cartCount={cart.length}>
            <Outlet />
        </StorefrontLayout>
    );
};

/** Lädt die Storefront zum Slug (`/store/:slug/*`) und stellt Kontext + Layout bereit. */
const StorefrontRoot: React.FC = () => {
    const { slug = '' } = useParams<{ slug: string }>();
    const { t } = useStorefrontT();
    const [storefront, setStorefront] = useState<PublicStorefront | null>(null);
    const [error, setError] = useState<'notFound' | 'load' | null>(null);

    useEffect(() => {
        let cancelled = false;
        setStorefront(null);
        setError(null);
        publicStorefrontApi
            .get(slug)
            .then((data) => !cancelled && setStorefront(data.storefront))
            .catch((e) => !cancelled && setError(e instanceof StorefrontApiError && e.status === 404 ? 'notFound' : 'load'));
        return () => {
            cancelled = true;
        };
    }, [slug]);

    if (error) {
        return (
            <Box sx={{ p: 4, maxWidth: 560, mx: 'auto' }}>
                <Alert severity="warning">{error === 'notFound' ? t('notFound') : t('loadError')}</Alert>
            </Box>
        );
    }
    if (!storefront) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 8 }} role="status" aria-busy="true">
                <CircularProgress />
            </Box>
        );
    }
    return (
        <StorefrontProvider slug={slug.toLowerCase()} storefront={storefront}>
            <Frame />
        </StorefrontProvider>
    );
};

export default StorefrontRoot;
